var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mp-selector" }, [
    _c(
      "div",
      { staticClass: "mp-list" },
      [
        _c(
          "div",
          { staticClass: "mp-search" },
          [
            _c("text-field", {
              attrs: {
                placeholder: _vm.$mpt(_vm.$t("field.sensor_filter")),
                "prepend-inner-icon": "mdi-magnify",
                "hide-details": "",
                dense: "",
                "data-testid": "sensor_filter",
              },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.groups, function (group) {
          return _c(
            "div",
            { key: group.type, staticClass: "mp-group" },
            [
              _c(
                "div",
                {
                  staticClass: "mp-group__title",
                  attrs: { "data-testid": "sensor_group_title" },
                },
                [_vm._v(_vm._s(group.label))]
              ),
              _vm._v(" "),
              _vm._l(group.sensors, function (sensor) {
                return _c("v-checkbox", {
                  key: sensor.id,
                  attrs: {
                    value: sensor.id,
                    "hide-details": "",
                    dense: "",
                    "data-testid": "sensor_checkbox",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "mp-item",
                                attrs: {
                                  "data-testid": "monitoring_point_item",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "mp-item__head" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mp-item__name text-truncate min-w-0",
                                        attrs: {
                                          title: sensor.name,
                                          "data-testid": "sensor_name",
                                        },
                                      },
                                      [_vm._v(_vm._s(sensor.name))]
                                    ),
                                    _vm._v(" "),
                                    sensor.status
                                      ? _c("status-chip", {
                                          staticClass: "ml-auto flex-shrink-0",
                                          attrs: { status: sensor.status },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                sensor.place
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mp-item__place text-truncate min-w-0",
                                        attrs: {
                                          title: sensor.place,
                                          "data-testid": "sensor_place",
                                        },
                                      },
                                      [_vm._v(_vm._s(sensor.place))]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.selectedIds,
                    callback: function ($$v) {
                      _vm.selectedIds = $$v
                    },
                    expression: "selectedIds",
                  },
                })
              }),
            ],
            2
          )
        }),
        _vm._v(" "),
        _vm.isEmpty
          ? _c(
              "div",
              {
                staticClass: "mp-empty",
                attrs: { "data-testid": "no_applicable_sensors_message" },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$mpt(_vm.$t("msg.no_applicable_sensors"))) +
                    "\n    "
                ),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }